import {Injector} from "@angular/core";

export class RootInjectorService {
  public static injector: Injector;
}
